import {showErrorNotification, showSuccessNotification} from "../../global/notifications";

const _id = $('[name=Id]').val();
let _readonly = $('.review-status-checkbox').prop('checked');

export default function () {
    attachSaveEvent();
    attachStatusChangeEvent();
}

const attachSaveEvent = () => {
    const $saveButtons = $('button[data-comment-for]');
    if ($saveButtons.length) {
        $saveButtons.bind('click', function () {
            const $this = $(this);
            $this.attr('disabled', true);
            saveComments($this.data('comment-for'))
                .then(msg => showSuccessNotification(msg))
                .catch(error => showErrorNotification(error))
                .finally(() => $this.attr('disabled', false))
        })
    }
}

const saveComments = (commentFor) => {
    return new Promise((resolve, reject) => {
        let data = {
            id: _id,
            commentFor: commentFor,
            comment: $(`textarea[name=${commentFor}-comments]`).val()
        }
        $.post('/Operations/ScheduleFive/SaveComments', data, function (response) {
            if (response && response.success) resolve(response.message);
            else reject(response.message);
        });
    })
}

const attachStatusChangeEvent = () => {
    const $reviewStatus = $('.review-status-checkbox');
    if ($reviewStatus.length) {
        $reviewStatus.bind('change', function () {
            _readonly = $(this).prop('checked');
            updateStatus(_readonly)
                .then(msg => showSuccessNotification(msg))
                .then(_ => toggleComments(!_readonly))
                .then(_ => toggleGrids())
                .catch(error => revertStatus(error))
        });
    }
}

const updateStatus = (readyForReview) => {
    return new Promise((resolve, reject) => {
        let data = {
            id: _id,
            readyForReview: readyForReview
        }
        $.post('/Operations/ScheduleFive/UpdateStatus', data, function (response) {
            if (response && response.success) resolve(response.message);
            else reject(response.message);
        })
    });
}
const revertStatus = (error) => {
    const $reviewStatus = $('.review-status-checkbox');
    if ($reviewStatus.length) {
        $reviewStatus.prop('checked', !$reviewStatus.prop('checked'))
    }
    showErrorNotification(error);
}
const toggleComments = (enabled) => {
    //Disable TextFields
    $('textarea').attr('disabled', !enabled);
    
    //Hide button
    if (enabled) $('button[data-comment-for]').show();
    else $('button[data-comment-for]').hide();

    $(document).trigger('on:UiUpdate');
}
const toggleGrids = () => {
    const $resourceEntry = $('.k-resource-entry').not('.js-cost')
    $.each($resourceEntry, function(index, ele){
        const k_resourceEntry = $(ele).data('kendoResourceEntry');
        if(k_resourceEntry) k_resourceEntry.toggleReadonly(_readonly);
    });
}
